module.exports = __webpack_public_path__ + "static/nimblewright-7096840e7d97efa04bd3f133e9bba509.png";